import type {
  WidgetChange,
  WidgetChangesRequest,
  WidgetChangesTimeline,
} from '@shared/api/widget-changes-api';

/** Explicit preview data for ?changes_demo=1; never written to analytics. */
export const buildChangesDemo = (request: WidgetChangesRequest): WidgetChangesTimeline => {
  const end = new Date(request.date_to.endsWith('Z') ? request.date_to : `${request.date_to}Z`);
  const from = new Date(
    request.date_from.endsWith('Z') ? request.date_from : `${request.date_from}Z`,
  );
  if (Number.isNaN(end.getTime()) || Number.isNaN(from.getTime())) {
    return { interval: request.interval, buckets: [] };
  }

  if (request.interval === 'day') end.setUTCHours(0, 0, 0, 0);
  else end.setUTCMinutes(0, 0, 0);
  const earlier = new Date(end.getTime() - (request.interval === 'day' ? 86_400_000 : 3_600_000));

  const event = (
    id: number,
    bucket: Date,
    source: 'agent' | 'widget_settings',
    property_name: string,
    old_value: unknown,
    new_value: unknown,
    action: WidgetChange['action'] = 'changed',
    position: number | null = null,
  ): WidgetChange => ({
    id,
    change_group: id === 4 ? 'demo-previous' : source === 'agent' ? 'demo-agent' : 'demo-preset',
    agent_id: source === 'agent' ? 1 : null,
    widget_settings_id: source === 'widget_settings' ? 2 : null,
    actor_id: 1,
    entity_type: source,
    entity_id: source === 'agent' ? 1 : 2,
    property_name,
    action,
    position,
    old_value,
    new_value,
    created_at: new Date(bucket.getTime() + 12 * 60_000 + id * 60_000).toISOString(),
    subject_name: source === 'agent' ? 'Демо-агент' : 'Демо-пресет',
    actor_name: 'Демо-пользователь',
  });

  const current = [
    event(1, end, 'agent', 'style', 'Формальный', 'Дружелюбный'),
    event(2, end, 'agent', 'rules', '5. Отвечать кратко', '5. Отвечать подробно', 'changed', 5),
    event(3, end, 'widget_settings', 'appearance.button_theme', 'light', 'dark'),
    {
      ...event(5, end, 'agent', 'knowledge_base_id', null, 4, 'added'),
      entity_type: 'knowledge',
      entity_id: 4,
      entity_name: 'Ответы на частые вопросы',
      new_value_name: 'Ответы на частые вопросы',
    },
  ];
  const buckets: WidgetChangesTimeline['buckets'] = [];
  if (earlier >= from) {
    buckets.push({
      date: earlier.toISOString(),
      change_count: 1,
      latest: [
        event(
          4,
          earlier,
          'widget_settings',
          'content.welcome_message',
          'Здравствуйте!',
          'Рады вас видеть!',
        ),
      ],
    });
  }
  if (end >= from)
    buckets.push({
      date: end.toISOString(),
      change_count: new Set(current.map((change) => change.change_group)).size,
      latest: current,
    });
  return { interval: request.interval, buckets };
};
